<template>
  <div class="latestNews">
    <div class="latestNews__heading">
      latest news
    </div>
    <div class="latestNews__content">
      <div class="article" v-for="(news, index) in latestNews" :key="index">
        <div class="article__sectionLable">
          <amp-label :node="news" mode="latestNews"></amp-label>
        </div>
        <a :href="newsUrl(news)" v-if="newsUrl">
          <div class="article__title">{{title(news)}}</div>
          <div class="article__image">
            <amp-img v-bind:src="thumbnail(news)"
                      width="400"
                      layout="responsive"
                      height="300">
            </amp-img>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import map from 'lodash/map'
  import reject from 'lodash/reject'
  import mixinSection from 'components/mixins/section'
  
  export default {
    name: 'amp-latest-news',
    props: ['node'],
    mixins: [mixinSection],
    components: {
      AmpLabel: () => import('components/article/amp/AmpLabel'),
    },
    computed: {
      latestNews() {
        const nodeTid = this.getLastSection(get(this, 'node.sections', []))
        const nodeQueue = this.$store.getters.nodeQueue(`section_top-${nodeTid}`) || {}
        const list = map(nodeQueue, this.getNode)
        return reject(list, {nid: this.node.nid}).slice(0, 3)
      },
    },
    methods: {
      getNode(nid) {
        return this.$store.state.nodes[nid]
      },
      title(node) {
        return get(node, 'title', '')
      },
      thumbnail(node) {
        return get(node, 'images[0].style_134w', '/image/placeholder/32/40/5A9CB5/20')
      },
      newsUrl(node) {
        return get(node, 'relative_url', '')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .latestNews {
    border-top: 2px solid $manatee2;
    margin-top: rem-calc(30);
    margin-left: rem-calc(20);
    margin-right: rem-calc(20);
    padding-top: rem-calc(20);
    
    &__heading {
      text-transform: uppercase;
      color: $specification-grey;
      font-size: rem-calc(20);
      font-weight: bold;
      padding-bottom: rem-calc(5);
    }

    &__content {
      padding-left: rem-calc(8);
      padding-right: rem-calc(8);
      position: relative;
      overflow: hidden;
    }

    .article {
      margin-top: rem-calc(12);
      overflow: hidden;
      position: relative;

      a {
        display: block;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $rose;
        padding-bottom: rem-calc(16);

        &:after {
          background-color: $rose;
          bottom: rem-calc(3);
          content: "";
          position: absolute;
          width: 100%;
          height: rem-calc(1);
          left: 0;
        }
      }

      &__title {
        color: $dark-jungle-green;
        font-size: rem-calc(24);
        height: rem-calc(87);
        width: 66%;
        float: left;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: rem-calc(8);
      }

      &__image {
        color: $dark-jungle-green;
        font-size: rem-calc(24);
        width: 33%;
        float: right;
        margin-top: rem-calc(8);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// AmpLatestNews.vue?30261a56